import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import api from "api/api";

function Dashboard() {
  const [data, setData] = useState({
    tot_faqs: 0,
    tot_users: 0,
    tot_page: 0,
    tot_service: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await api.get("admin/dashboard");
        if (response.data.status) {
          setData({
            tot_faqs: response.data.tot_faqs,
            tot_users: response.data.tot_users,
            tot_page: response.data.tot_page,
            tot_service: response.data.tot_service,
          });
        } else {
          setError("Failed to load dashboard data.");
        }
      } catch (err) {
        setError("Error fetching dashboard data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="groups"
                title="Total Users"
                count={data.tot_users}
                percentage={{
                  color: "success",
                  label: (
                    <a href="/users" style={{ color: "inherit", textDecoration: "underline" }}>
                      More info
                    </a>
                  ),
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="help"
                title="Total FAQs"
                count={data.tot_faqs}
                percentage={{
                  color: "success",
                  label: (
                    <a href="/faqs" style={{ color: "inherit", textDecoration: "underline" }}>
                      More info
                    </a>
                  ),
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="description"
                title="Total Pages"
                count={data.tot_page}
                percentage={{
                  color: "success",
                  label: (
                    <a href="/page" style={{ color: "inherit", textDecoration: "underline" }}>
                      More info
                    </a>
                  ),
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="build"
                title="Total Services"
                count={data.tot_service}
                percentage={{
                  color: "success",
                  label: (
                    <a href="/service" style={{ color: "inherit", textDecoration: "underline" }}>
                      More info
                    </a>
                  ),
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
